import React, { Component } from "react";
import PropTypes from "prop-types";
import { Button } from "reactstrap";
import MediaQuery from "react-responsive";

class ExportCSV extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <MediaQuery minDeviceWidth={this.props.minWidth || 600}>
        {(matches) => {
          if (matches) {
            return (
              <Button
                disabled={this.props.disabled}
                className={
                  this.props.maxSide == "left"
                    ? "ml-2 float-left"
                    : "ml-2 float-right"
                }
                color="primary"
                onClick={this.props.exportCSV}
              >
                {this.props.detailed
                  ? "Descargar Reporte Detallado"
                  : "Descargar Reporte"}
              </Button>
            );
          } else {
            return (
              <Button
                disabled={this.props.disabled}
                className={
                  this.props.minSide == "right"
                    ? "ml-2 mt-2 float-right"
                    : "mr-2 mt-2 float-left"
                }
                color="primary"
                onClick={this.props.exportCSV}
              >
                {this.props.detailed
                  ? "Descargar Reporte Detallado"
                  : "Descargar Reporte"}
              </Button>
            );
          }
        }}
      </MediaQuery>
    );
  }
}

export default ExportCSV;



// WEBPACK FOOTER //
// ./src/components/CSV/ExportCSV/ExportCSV.js